export default __webpack_public_path__ + "static/media/Settings_LineSpacing.4175a8d7.svg";